import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

type ModalDescriptionProps = {
  text: string
}

const ModalDescription = ({ text }: ModalDescriptionProps) => (
  <Wrapper>
    <Text>{text}</Text>
  </Wrapper>
)

const Wrapper = styled.div`
  margin: 24px 0 32px;
`

export default ModalDescription
